import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { ProgressBar } from "primereact/progressbar";
import { FileUpload } from "primereact/fileupload";
import { toast } from "react-toastify";
import Label from "../fields/Label";
import { Button } from "primereact/button";

import "./file-upload.scss";

const CustomFileUpload = ({
  onUpload,
  onClear,
  fileType,
  uploading,
  progress,
  label = "upload",
  name,
  readOnly = false,
  fileUrl = "",
  imageStyleProps = {},
  error,
  messageAfterUpload = "",
  infoMessages = [],
  uploadDetails,
  shouldManualUpload = true,
  required = false,
  maxFileSize = 1048576000,
  inputLabel,
  isImage = false,
}) => {
  const intl = useIntl();
  const uploadRef = useRef(null);
  const [file, setFile] = useState(null);

  useEffect(() => {
    if (uploadRef.current && error) {
      uploadRef.current.clear();
      setFile(null);
    }
  }, [uploadRef, error]);

  return (
    <div className="edexlms-field edexlms-file-upload" data-testid={`upload-${name}`}>
      <Label
        label={intl.formatMessage({ id: label })}
        required={required}
        disabled={readOnly}
      />
      {(!readOnly && (
        <>
          <div className="flex gap-2">
            <FileUpload
              ref={uploadRef}
              name={`${name}[]`}
              customUpload
              auto={false}
              multiple={false}
              onSelect={(e) => {
                if (e.files.length) {
                  setFile(e);
                }
                if (!shouldManualUpload) {
                  onUpload(e);
                }
              }}
              onValidationFail={(e) => {
                toast.error(intl.formatMessage({ id: "upload_size_error" }));
              }}
              mode="basic"
              accept={fileType}
              maxFileSize={maxFileSize}
              pt={
                inputLabel ? { input: { "aria-label": inputLabel } } : undefined
              }
            />
            {(file?.files.length &&
              shouldManualUpload &&
              !uploading &&
              !uploadDetails && (
                <Button
                  outlined
                  type="button"
                  onClick={() => onUpload(file)}
                  data-testid="upload-start"
                  icon="pi pi-upload"
                />
              )) ||
              null}
            {(file && !uploading && (
              <Button
                type="button"
                severity="danger"
                outlined
                onClick={() => {
                  if (onClear) onClear();
                  if (uploadRef.current) {
                    uploadRef.current.clear();
                  }
                  setFile(null);
                }}
                data-testid="upload-clear"
                icon="pi pi-times"
              />
            )) ||
              null}
          </div>
          {(infoMessages.length && (
            <ul className="info-messages">
              {infoMessages.map((message, index) => (
                <li key={index} className="message">
                  {message}
                </li>
              ))}
            </ul>
          )) ||
            null}
        </>
      )) ||
        null}
      {(readOnly && fileUrl && isImage && (
        <div className="edexlms-image-preview">
          <img src={fileUrl} alt={name} style={{ ...imageStyleProps }} />
        </div>
      )) ||
        null}
      {uploading && progress < 100 && (
        <ProgressBar className="edexlms-progress-bar" value={progress} />
      )}
      {(progress === 100 && fileType === ".zip" && messageAfterUpload && (
        <div className="upload-successful-message">
          {intl.formatMessage({ id: messageAfterUpload })}
        </div>
      )) ||
        null}
    </div>
  );
};

export default CustomFileUpload;
